import { POST } from "@/utils/axios";

export function getAuthToken(data) {
    return POST('/user/getAuthToken', data);
}

export function getAuthTokenByAppId(data) {
    return POST('/user/getAuthTokenByAppId', data)
}

export function checkAuthTokenInfo(data) {
    return POST('/auth/checkUserToken', data)
}